import { useRouter } from 'next/router';
import { usePreviousRoute } from './usePreviousRoute';

export const useNavigateToPreviousRoute = (
  fallbackUrl: string,
): (() => Promise<void>) => {
  const router = useRouter();
  const previousRoute = usePreviousRoute();

  return async (): Promise<void> => {
    await router.replace(previousRoute ?? fallbackUrl);
  };
};
